import { pluck } from '../utilities'
export default {
    props: {
        page: {
            type: Number,
            default: 1
        },
        per_page: {
            type: Number,
            default: 25
        },
        sort_by: String,
        sort_dir: {
            type: String,
            default: 'asc'
        }
    },
    data () {
        return {
            tableParamDefaultKeys: [ 'page', 'per_page', 'sort_by', 'sort_dir' ],
            tableParamKeys: [],
            scrollsOnChange: true
        }
    },
    computed: {
        tableMergedKeys () {
            return [ ...this.tableParamDefaultKeys, ...this.tableParamKeys ]
        }
    },
    methods: {
        pageChange (page) {
            let params = this.getParameters()
            params.page = page
            this.setParameters(params)
        },
        sizeChange (amount) {
            let params = this.getParameters()
            params.per_page = amount
            this.setParameters(params)
        },
        sortChange (sort) {
            let params = this.getParameters()
            params.sort_by = sort.prop
            params.sort_dir = sort.order == 'descending' ? 'desc' : 'asc'
            this.setParameters(params)
        },
        setParameters (query) {
            this.$router.replace({ query: this.paramTransformer(query) })
            if (this.scrollsOnChange) {
                document.body.scrollTop = document.documentElement.scrollTop = 0
            }
            this.paramsChanged(query)
        },
        paramsChanged () {},
        paramTransformer (query) { return query },
        paramResolver (query) { return query },
        getParameters () {
            return this.paramResolver(pluck(this, this.tableMergedKeys))
        },

        parseJson (value) {
            if (value) {
                return JSON.parse(value)
            }
            return [] 
        },
        setJson (key, value) {
            var parameters = this.getParameters()
            parameters[key] = JSON.stringify(value)
            this.setParameters(parameters)
        }
    }
}
